module.exports = __webpack_public_path__ + "node_modules/icheck/skins/flat/orange@2x.png?97f1f8c8";